import { HttpClient } from '@angular/common/http';
import { Service, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { AuthResponse, AuthTokenRequest } from '@interfaces/auth.interface';
import { Host, HostNameResponse } from '@interfaces/host.interface';
import { API_URL } from '@mocks/api.constants';

@Service()
export class AuthService {
  private readonly _http = inject(HttpClient);
  private readonly _authUrl = API_URL.RENTSODY_AUTH;
  private readonly _boUrl = API_URL.RENTSODY_BO;

  /**
   * Validate host by external code name
   * Returns host name if valid
   */
  validateHost(externalCodeName: string): Observable<HostNameResponse> {
    return this._http.get<HostNameResponse>(
      `${this._authUrl}/externalCodeName/${externalCodeName}`
    );
  }

  getHost(): Observable<Host> {
    return this._http.get<Host>(`${this._boUrl}/hosts`);
  }

  login(credentials: AuthTokenRequest): Observable<AuthResponse> {
    return this._http.post<AuthResponse>(`${this._authUrl}/token`, credentials);
  }

  /**
   * Refresh access token using refresh token
   * Backend: POST /auth/refresh-token
   */
  refreshToken(refreshToken: string): Observable<AuthResponse> {
    return this._http.post<AuthResponse>(`${this._authUrl}/refresh-token`, { refreshToken });
  }
}
